module.exports = __webpack_public_path__ + "static/media/cex.36936de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/exchanges/cex.png
// module id = 99
// module chunks = 0